export const regionCode = {
  CN: '+86',
  US: '+1',
  VN: '+84',
  SG: '+65'
}

const initFormat = [
  '',
  '(x)',
  '(xx)',
  '(xxx)',
  '(xxx) x',
  '(xxx) xx',
  '(xxx) xxx',
  '(xxx) xxxx',
  '(xxx) xx-xxx',
  '(xxx) xxx-xxx',
  '(xxx) xxx-xxxx'
]

const getFormat = (length: number): string =>
  initFormat.length > length ? initFormat[length] : getFormat(length - 4) + '-xxxx'

const lazyInit = () => {
  for (let i = initFormat.length; i <= 50; i++) {
    initFormat.push(getFormat(i))
  }
}

export const splitRegion = (raw: string) => {
  if (!raw) {
    return {
      code: '',
      remain: ''
    }
  }
  const code = Object.values(regionCode).find((code) => raw.startsWith(code)) || ''
  const remain = raw.slice(code?.length).replace(/[^0-9]/g, '')
  return { code, remain }
}

export const formatMobileNumber = (raw: string | null | undefined) => {
  lazyInit()
  if (!raw) {
    return ''
  }
  const { code, remain } = splitRegion(raw)
  const format = getFormat(remain.length)
  const placeHolder = format.split('')
  const matchAll = [...format.matchAll(/x/g)]
  matchAll.map((g, index) => {
    if (g.index) {
      placeHolder[g.index] = remain[index]
    }
  })
  return `${code ? `${code} ` : ''}${placeHolder.join('')}`
}
